import { DocumentReference } from "firebase/firestore"
import { useDiscountCodes } from "hooks/firestore/simple/useDiscountCodes"
import { useState } from "react"
import DiscountCode from "types/firestore/discountCode"
import DiscountCodeEditModal from "./CodeEditModal"
import DiscountCodeListLine from "./CodeListLine"
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./DiscountCodes.module.scss"

export default function DiscountCodeList() {
  const discountCodes = useDiscountCodes()

  const [editingDiscountCodeRef, setEditingDiscountCodeRef] = useState<
    undefined | "newCode" | DocumentReference<DiscountCode>
  >(undefined)
  const setModal = (ref: DocumentReference<DiscountCode> | "newCode" | undefined) => {
    setEditingDiscountCodeRef(ref)
  }
  return (
    <div className={styles.wrapper}>
      <DiscountCodeEditModal docRef={editingDiscountCodeRef} close={() => setModal(undefined)} />
      <div className={styles.headline}>
        <h2>Deine Rabattcodes</h2>
        <button onClick={() => setModal("newCode")}>+ Neuer Code</button>
      </div>

      {(discountCodes || []).length ? (
        <table>
          <thead>
            <tr>
              <th>Status</th>
              <th>Code</th>
              <th className={styles.right}>Wert</th>
              <th className={styles.right}>Nutzung</th>
            </tr>
          </thead>
          <tbody>
            {(discountCodes || []).map(discountCode => (
              <DiscountCodeListLine key={discountCode._ref.id} discountCode={discountCode} setModal={setModal} />
            ))}
          </tbody>
        </table>
      ) : (
        <p style={{ margin: "1rem" }}>
          Du hast noch keine Discount Codes erstellt. Diese erscheinen nach dem Anlegen hier.{" "}
        </p>
      )}
    </div>
  )
}
